export default "__VITE_ASSET__DfZVfKMo__"